<template>
  <div class="down">
    <div
      class="official"
      :class="[deviceType(), position]"
    >
      <!-- ios 下载 -->
      <div
        v-if="showAppStore"
        :class="indexPopUpLoadBtnWith? 'wapBtn': ''"
        class="appStore"
      >
        <a
          :href="store.state.articlesData.appStore"
          target="_blank"
        >
          <img
            :class="iosCounts"
            v-if="(position == 'gw' && deviceType() == 'wap')"
            src="../pages/zth/assets/images/apple-long.gif"
          >
          <img
            v-else
            :class="iosCounts"
            :src="store.state.articlesData.appStoreImg"
          >
        </a>
      </div>
      <!-- 谷歌下载 -->
      <div
        v-if="showGooglePlay"
        :class="indexPopUpLoadBtnWith? 'wapBtn': ''"
        class="googlePlay"
      >
        <a
          :href="store.state.articlesData.googlePlay"
          target="_blank"
        >
          <img
            :class="androidCounts"
            v-if="(position == 'gw' && deviceType() == 'wap')"
            src="../pages/zth/assets/images/google-long.gif"
          >
          <img
            v-else
            :class="androidCounts"
            :src="store.state.articlesData.googlePlayImg"
          >
        </a>
      </div>
    </div>
    <div
      class="other"
      :class="[deviceType(), position]"
      v-if="position == 'gw' || (position == 'gwSideInfo' && deviceType() == 'pc')"
    >
      <!-- apk下载 -->
      <div class="apk">
        <div
          @click="Expect(store.state.articlesData.apk,$t('reserve.other.Expect'))"
          target="_blank"
        >
          <img
            :class="apkCounts"
            v-if="XhLang == 'cn'"
            src="../pages/zth/assets/images/APK-cn.png"
          >
          <img
            :class="apkCounts"
            v-if="XhLang == 'th'"
            src="../pages/zth/assets/images/APK-th.png"
          >
          <img
            :class="apkCounts"
            v-if="XhLang == 'en'"
            src="../pages/zth/assets/images/APK-en.png"
          >
        </div>
      </div>
      <!-- FB -->
      <div
        class="FB"
        v-if="isNa"
      >
        <a
          :href="store.state.articlesData['fbPage' + XhLang.toUpperCase()]"
          target="_blank"
        >
          <img
            v-if="XhLang == 'cn'"
            :class="FBCounts"
            src="../pages/zth/assets/images/FB-cn.png"
          >
          <img
            v-else
            :class="FBCounts"
            src="../pages/zth/assets/images/FB-en.png"
          >
        </a>
      </div>
      <!-- 华为下载 -->
      <div
        class="huawei"
        v-else
      >
        <div
          @click="Expect(store.state.articlesData.huawei, $t('reserve.other.Expect'))"
          target="_blank"
        >
          <img
            :class="huaweiCounts"
            src="../pages/zth/assets/images/HuaWei.png"
          >
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { defineProps, computed, ref } from "vue";
import { getSystem, deviceType, Expect } from "@/util/base";

import { projectType } from "@/util/global";
const isNa = projectType().area.indexOf("na") !== -1;

import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const XhLang = locale.value;

import { useStore } from "vuex";
const store = useStore();

defineProps([
  "position",
  "iosCounts",
  "androidCounts",
  "apkCounts",
  "huaweiCounts",
  "finger",
  "indexPopUpLoadBtn",
]);

const indexPopUpLoadBtnWith = ref(false);

const showAppStore = computed(
  () => getSystem() === "PC" || getSystem() === "iOS"
);
const showGooglePlay = computed(
  () => getSystem() === "PC" || getSystem() === "android"
);
</script>

<style lang=scss scoped>
.reserveShop.pc {
  display: flex;
  > div {
    width: 2rem;
  }
}

.gwSideInfo.pc {
  .appStore,
  .googlePlay {
    display: none;
  }
}

.appStore,
.googlePlay,
.apk,
.huawei,
.FB {
  width: 2.19rem;
  height: 0.69rem;
  margin: 0.05rem 0;
  cursor: pointer;
  &.wapBtn {
    width: 3.64rem;
  }
  img {
    width: 100%;
  }
  a {
    width: 100%;
    display: block;
    img {
      width: 100%;
    }
  }
}

.other {
  display: flex;
  margin: 0 0.1rem;
  > div {
    margin: 0.1rem;
  }
}

.wapkv {
  > div {
    width: 2rem;
    height: 0.64rem;
  }

  .appStore,
  .googlePlay {
    margin: 1.15rem 0 0 2.65rem;
  }
}

.pckv {
  > div {
    width: 2rem;
    height: 0.64rem;
  }

  .appStore {
    margin: 0.75rem 0 0 2.65rem;
  }

  .googlePlay {
    margin: 0.1rem 0 0 2.65rem;
  }
}

.firstPop {
  display: flex;
  > div {
    width: 2.1rem;
    height: 0.7rem;
    margin: 0 0.05rem;
    &.wapBtn {
      width: 3.64rem;
    }
  }
}

.gw {
  display: flex;
  margin: 0 0.1rem;
  > div {
    margin: 0 0.1rem;
  }
  &.other {
    margin: 0.1rem 0.1rem;
  }
  &.wap {
    > div {
      width: 100%;
      margin: 0.2rem 0.1rem;
    }
    .appStore,
    .googlePlay {
      margin: 0.5rem 0;
    }
  }
}

.sideInfo,
.gwSideInfo {
  > div {
    width: 1.7rem;
    height: 0.7rem;
  }
  &.pc {
    display: flex;
    flex-direction: column;
    > div {
      width: 2.01rem;
      height: 0.55rem;
      margin: 0.1rem 0;
    }
  }
  &.wap {
    .appStore,
    .googlePlay {
      margin: 0;
    }
  }
}
.other {
  &.gwSideInfo {
    display: flex;
    flex-direction: column;
    > div {
      width: 2.01rem;
      height: 0.6rem;
    }
  }
  &.gw.wap {
    > div {
      margin: 0 0.1rem;
    }
  }
}
</style>